import {API} from '../API';
import PaginatedList from '../PaginatedList';
import Licensee from '../../models/Licensee';
import {store} from '../../redux/StoreReducers';

const LicenseesApiService =  {
    get: async (pageNumber = 1, keyword = '') => {
        const {data: response} = await API.get(
            `/licensees/?page=${pageNumber}&search=${keyword}`,
        );
        const list = new PaginatedList();
        list.items = response.data.map((licensee) => new Licensee(licensee));
        list.page = response.meta.page;
        list.pageCount = response.meta.lastPage;
        list.pageSize = response.meta.perPage;
        list.total = response.meta.total;
        return list;    
    },

    detail: async(id) => {
        const {data: response} = await API.get(`/licensees/${id}`);
        const licensee = new Licensee(response.data);
        return licensee;
    },

    save: async (input) => {
        await API.post(`/licensees/`, input, {
            headers: {'Accept-Language': store.getState().langReducer.lang},
        });
        return {};
    },

    update: async (id, params) => {
        const response = await API.put(`/licensees/${id}`, params);
        return {licensee: new Licensee(response.data)};
    },

    delete: async (id) => {
        await API.delete(`/licensees/${id}`);
        return {};
    },

    all: async () => {
        const {data: response} = await API.get(`/licensees/all`);
        return response.data;
    }
}

export default LicenseesApiService;